<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-group"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1 white">
        <v-col cols="12">
          <v-row class="d-flex align-center mt-5 mx-5 ">
            <v-col cols="1"> Name:</v-col>
            <v-col cols="4">
              <v-text-field
                  label="Name"
                  placeholder="Enter the  name "
                  filled
                  v-model="userDetail.name"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex align-center mt-n10 mx-5 ">
            <v-col cols="1"> Email:</v-col>
            <v-col cols="4">
              <v-text-field
                  readonly
                  label="Email"
                  placeholder="Enter email"
                  filled
                  v-model="userDetail.email"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex align-center mt-n10 mx-5 ">
            <v-col cols="1"> Date sign up:</v-col>
            <v-col cols="4">
              <v-menu
                  class="float-left"
                  v-model="menuSignUp"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field style="width: 100%"
                                aria-readonly=""
                                filled
                                class="mr-3 float-left"
                                v-model="userDetail.created_at"
                                placeholder="Select Date"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="userDetail.created_at"
                    @input="menuSignUp = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex align-center mt-n10  mx-5 ">
            <v-col cols="1"> Date end:</v-col>
            <v-col cols="4">
              <v-menu
                  class="float-left"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="width: 100%"
                      clearable
                      filled
                      class="mr-3 float-left"
                      v-model="computedDateFormatted"
                      placeholder="Select Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="userDetail.active_to"
                    @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex align-center mt-n10  mx-5 ">
            <v-col cols="1">Credits:</v-col>
            <v-col cols="4">
              <v-text-field
                  label="Credit"
                  placeholder="Enter the credit"
                  filled
                  v-model="userDetail.credits_sum_credit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <div class="download-history___text ">Downloads history</div>
          <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="userDetail.order_detail"
                :sort-by="['id']"
                :sort-desc="true"
                :items-per-page="10"
                class="elevation-1"
            >
              <template v-slot:item.photo_url="{ item }">
                <v-img :src="item.photo_url ? item.photo_url :''" aspect-ratio="1.7"></v-img>
              </template>

              <template v-slot:item.design_url="{ item }">
                <v-img :src="item.design_url ? url + item.design_url :''" aspect-ratio="1.7"></v-img>
              </template>
            </v-data-table>
          </v-col>
        </v-col>
        <v-row align="center" justify="center" class="mb-10 mt-2">
          <v-btn class="btn-save" @click="save">Save</v-btn>
        </v-row>
      </v-row>
    </v-container>
  </div>


</template>

<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_USER, UPDATE_USERS} from "@/store/modules/users";

export default {
  name: "EditUser",
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      page: "UserDetail",
      breadcrumbs: [
        {
          text: "Users",
          disabled: true,
        },
        {
          text: "User Detail",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "template_id", align: "start"},
        {text: "Image", value: "photo_url"},
        {text: "Image Design", value: "design_url"},
        {text: "Price", value: "price"},
      ],
      url: '',
      menu: false, menuSignUp: false,
      date_Sign_in:''
    }
  },
  computed: {
    ...mapGetters({
      userDetail: "userDetail"
    }),
    computedDateFormatted () {
      return this.formatDate1(this.userDetail.active_to)
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_USER}`, this.$route.params.id);
    this.url = process.env.VUE_APP_API_URL
     this.userDetail.created_at  = this.formatDate( this.userDetail.created_at )
  },
  methods:{
    formatDate1 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    async save() {
      let pattern = /\D/g;
      if(this.userDetail.credits_sum_credit.match(pattern)){
        alert("Credit must be digits!")
      }else{
        let data = {
          id:  this.$route.params.id,
          name:this.userDetail.name,
          active_to: this.userDetail.active_to,
          credit:this.userDetail.credits_sum_credit
        }
        await this.$store.dispatch(`${UPDATE_USERS}`, data).then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Update successful!', {
              duration: 1000,
              position: 'top-center'
            })
          } else {
            alert(data.data.errors)
          }
        });
      }

    }
  }

}
</script>

<style scoped>
.download-history___text {
  color: #191E21;
  font-weight: bolder;
  font-size: 20px;
  margin-left: 25px;
}
.btn-save{
  background-color: #191E21 !important;
  color: white !important;
  width: 20% !important;
}
</style>